import { MailingMode } from '@/admin/modules/priceLists/models';
import { t } from '@/core/localization';
const getMailingModeName = (mailingMode) => {
    switch (mailingMode) {
        case MailingMode.Weekdays: {
            return t('on.weekdays');
        }
        case MailingMode.Daily: {
            return t('everyday.label');
        }
        case MailingMode.Manually: {
            return t('manually.label');
        }
        default: {
            // TODO: to delete later (with following refactoring all over the project)
            // const exhaustiveCheck: never = mailingMode;
            // throw new Error(`Unhandled MailingMode case: ${exhaustiveCheck}`);
            throw new Error(`Unhandled MailingMode case: ${mailingMode}`);
        }
    }
};
export { getMailingModeName };
